export interface CsvImportRow {
  // 1-based line number in the pasted text, for error messages
  lineNumber: number
  data: Record<string, string>
}

// Parses pasted CSV for the bulk account import. The header line is optional:
// when the first line names the columns (it contains "email"), rows are matched
// by header name; otherwise every line is read positionally in `columns` order.
export const parseCsvImport = (csvData: string, columns: string[]): CsvImportRow[] => {
  // Excel 由来のCSVはCRLFなので、行末の \r を残さないよう分割・trimする
  const lines = csvData.trim().split(/\r?\n/)
  const firstCells = lines[0].split(',').map(cell => cell.trim())
  const hasHeader = firstCells.includes('email')

  if (hasHeader) {
    const missingHeaders = columns.filter(h => !firstCells.includes(h))
    if (missingHeaders.length > 0) {
      throw new Error(`CSVに必要な列がありません: ${missingHeaders.join(', ')}`)
    }
  }

  const headers = hasHeader ? firstCells : columns
  const rows: CsvImportRow[] = []
  for (let i = hasHeader ? 1 : 0; i < lines.length; i++) {
    if (!lines[i].trim()) continue
    const values = lines[i].split(',')
    const data: Record<string, string> = {}
    headers.forEach((header, index) => {
      data[header] = values[index]?.trim() || ''
    })
    rows.push({ lineNumber: i + 1, data })
  }
  return rows
}
